export const sv = {
  message: {
    overtime: {
      title: 'Övertid',
      from: 'Från',
      to: 'Till',
      fifty: 'Övertid 50%',
      hundred: 'Övertid 100%',
      total: 'Totalt',
      entries: 'Poster',
      noEntries: 'Ingen övertid under denna period.'
    },
    egenmelding: {
      title: 'Egenanmälan',
      report: 'Anmäl egenanmälan',
      type: 'Typ',
      own: 'Egen sjukdom',
      child: 'Sjukt barn',
      startDate: 'Från datum',
      days: 'Dagar',
      instances: 'tillfällen',
      remaining: 'Återstår',
      exhausted: 'Kvot förbrukad',
      ownDaysHint: 'Max 3 kalenderdagar per tillfälle',
      send: 'Skicka in',
      reported: 'Egenanmälan registrerad',
      quotaExceeded: 'Detta överskrider din återstående kvot',
      tooManyDays: 'Överskrider återstående dagar'
    },
    flex: {
      title: 'Flextid',
      balance: 'Flexsaldo',
      asOf: 'Per',
      policy: 'Regelverk',
      transactions: 'Transaktioner',
      transactionHistory: 'Transaktionshistorik',
      noTransactions: 'Inga transaktioner ännu.',
      avspasering: 'Kompledighet',
      requestAvspasering: 'Ansök om kompledighet',
      myRequests: 'Mina ansökningar',
      noRequests: 'Inga ansökningar om kompledighet ännu.',
      startDate: 'Från datum',
      endDate: 'Till datum',
      hours: 'Timmar',
      minutes: 'Minuter',
      comment: 'Kommentar',
      date: 'Datum',
      type: 'Typ',
      change: 'Förändring',
      submit: 'Skicka ansökan',
      cancelRequest: 'Återta ansökan',
      confirmCancel: 'Vill du återta denna ansökan om kompledighet?',
      requestSubmitted: 'Ansökan om kompledighet skickad!',
      requestCancelled: 'Ansökan återtagen.',
      overtimeRegistered: 'Övertid registrerad',
      overtime: 'Övertid',
      toFlexAccount: 'Till flexkonto (grundtimmar)',
      paidSupplement: 'Utbetalt tillägg',
      sendToFlex: 'Skicka till flexkonto',
      payOut: 'Betala ut',
      decideLater: 'Bestäm senare',
      decideNow: 'Bestäm nu',
      flexChoice: 'Flexval',
      choiceSaved: 'Valet är sparat.',
      noPendingLines: 'Ingen väntande övertid att ta ställning till.',
      choice: {
        pending: 'Väntar',
        flex: 'Flexkonto',
        payout: 'Utbetald'
      },
      state: {
        pending: 'Väntar',
        approved: 'Godkänd',
        denied: 'Avslagen',
        cancelled: 'Återtagen'
      },
      txType: {
        accrual: 'Intjäning',
        withdrawal_avspasering: 'Kompledighet',
        cap_excess_to_overtime: 'Över tak → övertid',
        cap_excess_dropped: 'Över tak → bortfaller',
        rollover: 'Överförd',
        payout: 'Utbetald',
        expire: 'Bortfaller',
        adjustment_manual: 'Manuell justering'
      }
    },
    dashboard: {
      edit: 'Redigera',
      done: 'Klar',
      reset: 'Återställ',
      theme: 'Tema',
      darkMode: 'Mörkt läge',
      featured: 'Utvalda',
      allModules: 'Alla moduler',
      dragToFeature: 'Dra moduler hit för att lyfta fram dem',
      editHint: 'Dra för att ändra ordning · ändringar sparas automatiskt',
      editHintFeatured: 'Dra en modul uppåt för att lyfta fram · dra nedåt för att ta bort',
      editHintBento: 'Dra för att ändra ordning · tryck på ⤢ för att ändra storlek · sparas automatiskt',
      layoutTiles: 'Rutor',
      layoutSections: 'Sektioner',
      layoutBento: 'Bento',
      sectionWork: 'Arbete',
      sectionResources: 'Resurser',
      sectionInfoMore: 'Info och mer',
      modules: 'Moduler',
      customizeModules: 'Anpassa moduler'
    },
    layout: {
      login: 'Inloggning',
      ortext: 'ELLER',
      logout: 'Logga ut',
      rfidsignin: 'Logga in med RFID',
      SignInpassword: 'Logga in med lösenord',
      ScanRFID: 'Skanna din RFID-tagg',
      dashboard: 'Dashboard',
      timer: 'Timer',
      projects: 'Projekt',
      stemp: 'Stemp',
      calendar: 'Kalender',
      deviation: 'Avvikelse',
      home: 'Hem',
      deliver: 'Leverera',
      more: 'Mer',
      files: 'Filer',
      equipments: 'Utrustning',
      checklists: 'Checklistor',
      drawing: 'Ritning',
      pressureTestReport: 'Tryckprovsrapport',
      weldlog: 'Loggbok för svetsning',
      event: 'händelse',
      ndt: 'NDT',
      surfaceReport: 'Ytrapport',
      technicalReport: 'Teknisk rapport',
      matrialList: 'Förteckning över material',
      pwht: 'PWHT',
      pwps: 'PWPS',
      wps: 'WPS',
      warehouse: 'Lager',
      tasks: 'Uppgifter',
      orders: 'Beställningar',
      facilities: 'Anläggning',
      chemicallist: 'Kemisk lista',
      asbuilt: 'Som byggt',
      autoLogout: 'automatisk utloggning'
    },
    login: {
      language: 'Språk',
      back: 'Tillbaka',
      userName: 'Användarnamn',
      password: 'Lösenord',
      authFailed: 'Autentisering misslyckades!',
      networkError: 'Kan inte nå servern. Kontrollera anslutningen och värdnamnet.',
      invalidCredentials: 'Fel användarnamn eller lösenord !',
      serverError: 'Servern kunde inte slutföra inloggningen. Kontakta supporten.',
      host: 'Värd',
      forgotPassword: 'Glömt lösenord?',
      forgotPasswordHint: 'Ange din e-postadress nedan för att återställa ditt lösenord.',
      backToLogin: 'Tillbaka till inloggning',
      emailAddress: 'E-postadress',
      resetMyPassword: 'Återställ mitt lösenord'
    },
    common: {
      pwaNotEnabled: 'PWA är inte aktiverat, kontakta administratören',
      delete_row: 'Ta bort rad',
      install: 'Installera den här applikationen på din hemskärm för snabb och enkel åtkomst när du är på språng.',
      justTab: 'Tryck bara på',
      addToHome: 'och sedan på "Lägg till på hemskärmen".',
      english: 'Engelska',
      norwegian: 'Norska',
      lithuanian: 'Litauiska',
      polish: 'Polska',
      swedish: 'Svenska',
      save: 'Spara',
      saveAndClose: 'Spara och stänga',
      send: 'Skicka',
      edit: 'Redigera',
      cancel: 'Avbryt',
      update: 'Uppdatera',
      delete: 'Ta bort',
      updateAndClose: 'Uppdatera och stänga',
      close: 'Stäng',
      new: 'Ny',
      isActive: 'Är aktiv',
      addNew: 'Lägg till nytt',
      savedSuccess: 'Sparad framgångsrikt!',
      addedSucess: 'Tillagd med framgång!',
      updatedSuccess: 'Uppdaterad med framgång !',
      deleteSuccess: 'Borttagen med framgång !',
      errorOccured: 'Ett fel uppstod !',
      backToList: 'Tillbaka till listan',
      search: 'Sök på',
      yes: 'Ja',
      no: 'Nej',
      isDefault: 'Är standard',
      loadingMsg: 'Laddar, vänligen vänta',
      deleteConfirm: 'Radera Bekräfta',
      areYouSure: 'Är du säker på att du vill radera?',
      validationIssue: 'Kontrollera de obligatoriska fälten!',
      total: 'Totalt',
      noResults: 'Inga resultat hittades !',
      statusUpdateFailed: 'Statusen sparades inte. Försök igen.',
      increaseHeight: 'Öka höjden',
      decreaseHeight: 'Minska höjden',
      others: 'Andra',
      typeHere: 'Skriv här...',
      position: 'Position',
      color: 'Färg',
      maxCharacters: 'Max {charCount} tecken',
      changedPassword: 'Lösenordet har ändrats med framgång',
      import: 'Importera',
      note: 'Anteckning',
      invalidEmail: 'Felaktigt e-postmeddelande',
      no_records: 'Inga poster hittades!',
      no_data: 'Inga uppgifter finns tillgängliga',
      ok: 'Ok',
      date: 'Datum',
      comments: 'Kommentarer',
      draftMsg: 'Sparad som utkast',
      createProjectRole: 'Skapa en projektroll',
      updateProjectRole: 'Uppdatera projektrollen',
      module: 'Modul',
      selectTemplate: 'Välj mall',
      documentTemplate: 'Dokumentmall',
      download: 'Ladda ner',
      uploadedSuccess: 'Uppladdning lyckad!',
      weekTotalHours: 'Veckans timmar',
      addWorktype: 'Lägg till arbetstyp',
      updateWorktype: 'Uppdatera arbetstyp',
      worktype: 'Arbetstyp',
      newUpdate: 'Ny uppdatering tillgänglig!',
      refresh: 'Uppdatera',
      retry: 'Försök igen',
      somethingWentWrong: 'Något gick fel',
      online: 'Ansluten',
      offline: 'Offline',
      moduleName: 'Modulens namn',
      updatedOn: 'Uppdaterad den',
      columns: 'Kolumner',
      confirmCancel: 'Bekräfta Avbryt',
      areYouSureCancel: 'Är du säker på att du vill avbryta?',
      not_approved_notification: 'Hej! {count} tidsregistrering(ar) i vecka {weeknumber} är inte godkänd.',
      hourExceedNotification: 'Angiven timme överstiger 24 timmar',
      options: 'Alternativ',
      label: 'Etikett',
      value: 'Värde',
      confirmStatusChange: 'Bekräfta Statusändring',
      areYouSureToChangeStatus: 'Är du säker på att du vill ändra status till {statusText}?',
      complete: 'komplett',
      incomplete: 'Ofullständig',
      name: 'Namn',
      number: 'Nummer',
      noPermission: 'Tyvärr! Du har inte rätt att {permissionType} {module}',
      charsLimit35: 'Ange högst {length} tecken.',
      confirmAddHour: 'Skiftet är slutfört!',
      sureToAddExceedingHour: 'Den angivna timmen överskrider arbetstiden. Är du säker på att du vill lägga till?',
      warning: 'Varning',
      required: 'Krävs',
      timerFeatureDisabled: 'Timer-funktionen är inaktiverad',
      locationNotSet: 'Platsen är inte inställd.',
      type: 'Typ',
      changeVideoSource: 'Ändra videokälla',
      permissionDenied: 'Kameratillstånd nekas!, aktivera det i webbläsarens inställningar!',
      time: 'Tid',
      orderno: 'Ordernr',
      ready_for_production: 'Klar för produktion',
      production: 'Produktion',
      on_hold: 'Vilande',
      finished: 'Färdig',
      of: 'av',
      ndt_percentage_error: 'NDT-procenten måste ha 0 till 100',
      lengthError: 'Längden måste vara mindre än 10',
      update_properties: 'Uppdatera egenskaper',
      add_properties: 'Lägg till egenskaper',
      preparing_fields: 'Förbereder fält...',
      from_attributs: 'FORMATRIBUT',
      enter_title: 'Ange titel på varje kolumn:',
      loading_grid: 'Laddar rutnät...',
      from_properties: 'FORM EGENSKAPER',
      dragging: 'Dra...',
      catch_up: 'Allt ikapp!!!',
      add_header: 'Lägg till rubrik',
      add_footer: 'Lägg till sidfot',
      drop_fields: 'Släpp fälten här',
      for_header: 'FÖR HUVUD',
      for_footer: 'FÖR Footer',
      add_html: 'LÄGG TILL HTML-INNEHÅLL',
      relate: 'Relatera',
      unrelate: 'Osläkt',
      values: 'Värderingar',
      scan: 'Skanna',
      filename: 'Filnamn',
      fitToScreen: 'Anpassa till skärmen',
      actualSize: 'Verklig storlek',
      zoomIn: 'Zooma in',
      zoomOut: 'Zooma ut',
      reset: 'Återställa',
      doYouWantContinue: 'Vill du fortfarande fortsätta?',
      stempHint: 'Om du väljer Shift kan du starta stämpeln',
      hoursExeed: 'överstiger 24 timmar',
      on: 'På',
      reachedHours: 'Nådde 24 timmar',
      invaliHours: 'Ogiltiga timmar',
      notValidNumber: 'Ej giltigt nummer',
      invalidName: 'Ogiltigt namn',
      filterSaveResult: 'Sökning gör att du kan se filtret du har tillämpat och det filtrerade resultatet kan endast ses i rapporten om du sparar checklistan',
      seemsInvalid: 'Timmar verkar inte vara giltiga!',
      shiftContinue: 'Din stemptimme fortsätter...',
      no_fields_found: 'Inga checklistfält hittades',
      sharePoint: 'Sharepoint kan ha felaktiga referenser eller konfigurationer saknas!.',
      dragAndDropTips: 'Att spara är obligatoriskt vid varje dra och släpp för att undvika felplacering av rader',
      afterCopyFilter: 'Filteracion kommer att utföras tills du sparar checklistan',
      archived: 'Arkiverat',
      datagrid_filter_help_text_1: 'Resultaten kommer att filtreras på samma sätt som förra gången filteralternativ.',
      datagrid_filter_help_text_2: 'När en ny rad läggs till kommer filter att tas bort och alla rader läggs till.',
      datagrid_filter_help_text_3: 'Filtren är skiftlägesokänsliga, så vi kan använda både versaler och gemener.',
      datagrid_filter_help_text_4: 'Vi kan inte filtrera samma kolumn två gånger.',
      datagrid_filter_help_text_5: 'Dra och släpp kommer att ändras av filterresultat, om användaren sparar checklistan.',
      datagrid_filter_help_text_6: 'Textområdet som filtreras av ordet mellan någon del av meningen.',
      datagrid_filter_help_text_7: 'Det är obligatoriskt att fylla i båda fälten och dess värde för att utföra filteråtgärder.',
      sharepointCharacters: "Det här fältet ska inte innehålla några av dessa tecken '*:<>?/\\|.'",
      company: 'Företag',
      filenotfound: 'Filen hittades inte',
      folder: 'Mapp',
      folders: 'Mappar',
      files: 'Filer',
      emptyFolder: 'Den här mappen är tom',
      emptyFolderHint: 'Publicerade dokument visas här',
      gridView: 'Rutnätsvy',
      listView: 'Listvy',
      back: 'Tillbaka',
      searchResults: 'Sökresultat',
      previousDocument: 'Föregående dokument',
      nextDocument: 'Nästa dokument',
      imagedraw: 'Rita på bild'
    },
    timer: {
      stop: 'Stoppa',
      ga_til_time: 'Gå till timlistan',
      minutes: 'minuter',
      start: 'Start',
      place: 'Plats',
      hours: 'Timmar',
      activity: 'Aktivitet',
      inactive_suffix: '(inaktiv)',
      not_linked_warning: 'Denna post överförs inte till {integration} — något är inte kopplat',
      pause: 'Paus',
      from: 'Från',
      till: 'Till',
      shift: 'Skiftlista',
      startTime: 'Starttid',
      endTime: 'Sluttid',
      editHours: 'Redigera timme',
      approved: 'Godkänd',
      notApproved: 'Inte godkänd',
      delivered: 'Levererat',
      notDelivered: 'Inte levererat',
      year: 'År',
      week: 'Vecka',
      nonBillable: 'Semester / Frånvaro',
      hourlogging: 'Timloggning',
      noHours: 'Inga timmar hittades för leverera !',
      deliveredMsg: 'Levererat framgångsrikt',
      addHours: 'Lägg till timme',
      deliverHours: 'Leverera timmar',
      hoursExceeding: 'Timer har överskridit 8 timmar',
      cancelTimer: 'Avbryt timer',
      uploadSuccess: 'Uppladdning lyckad',
      picture: 'Ta en bild',
      imageNeeded: 'Ladda upp en bild innan du stoppar timern!',
      nonbillableworktype: 'Semester / frånvarotyp',
      additionalWorktype: 'Ytterligare arbetstyp',
      additional_hours: 'Ytterligare timmar',
      overtimeToFlex: 'Skicka övertid till flexkonto',
      switchProject: 'Byt projekt',
      reasonForSwitchingProject: 'Anledning till att byta projekt',
      projectSwitchedSuccessfully: 'Projekt bytt framgångsrikt',
      failedToSwitchProject: 'Misslyckades med att byta projekt',
      selectDifferentProject: 'Vänligen välj ett annat projekt'
    },
    projects: {
      chatOpen: 'Öppna',
      chatEditMembers: 'Redigera deltagare',
      chatEditMembersHint: 'Kryssa i vilka som ska vara med i konversationen. Den som läggs till kan läsa hela historiken.',
      chatCreate: 'Skapa',
      chatParticipants: 'Deltagare',
      chatNewPrivate: '+ Ny',
      chatSend: 'Skicka',
      chatPrivate: 'Privat',
      chatSeenBy: 'Sett av {count}',
      chatSent: 'Skickat',
      chatEveryone: '{count} deltagare · alla med projektåtkomst',
      chatPrivateOnly: 'Endast {names} kan se denna konversation',
      chatNewPrivateTitle: 'Ny privat konversation',
      chatNewPrivateHint: 'Välj vem som kan se denna konversation.',
      chat: 'Chatt',
      chatConversations: 'Konversationer',
      chatEmpty: 'Inga meddelanden än.',
      chatPlaceholder: 'Skriv ett meddelande...',
      chatOpenWeldMapping: 'Open weld mapping',
      chatYou: 'du',
      chatEdited: 'redigerad',
      chatConfirmDelete: 'Ta bort detta meddelande?',
      chatToday: 'Idag',
      chatYesterday: 'Igår',
      startDate: 'Startdatum',
      endDate: 'Slutdatum',
      projectNo: 'Projektnr.',
      projectname: 'Projektnamn',
      aoRanked: 'AO Ranked',
      workOrderName: 'Arbetsordernamn',
      all: 'Alla',
      allActive: 'Alla Aktiva',
      myAll: 'Mina alla',
      myActive: 'Mina aktiva',
      project: 'Projekt',
      customer: 'Kund',
      status: 'Status',
      noActiveProjects: 'Inga aktiva projekt!',
      selectProject: 'Välj projekt',
      projectMaterialDisabled: 'Material som är inaktiverat för det här projektet',
      drawingGroup: 'Ritgrupp',
      sectionIdentification: 'Identifikation',
      sectionStatusAttachments: 'Status och bilagor',
      sectionReportDetails: 'Rapportdetaljer'
    },
    calendar: {
      today: 'Idag',
      month: 'Månad',
      day: 'Dag',
      weekNotExists: 'Veckan finns inte',
      yearValid: 'Måste vara fyra siffror',
      valid: 'Måste vara giltigt',
      yearTooLessValidation: 'Året måste vara större än 1920',
      weekLock: 'De valda datumen ligger i den låsta veckan',
      dayLocked: 'Det valda datumet ligger i den låsta veckan',
      otherHourEntries: 'Andra timangivelser'
    },
    shifts: {
      shift: 'Mina skift',
      documents: 'Dokument:',
      not_found: 'Ingen beskrivning och webbadress hittades.',
      notValidPausedTime: 'Paustiden är längre än skifttiden',
      continue: 'Fortsätta',
      clear: 'Klar',
      shiftEndsAt: 'Skiftet slutar kl.'
    },
    deviation: {
      deviations: 'Avvikelse',
      register_deviation: 'Registrera avvikelse',
      view_deviation: 'Visa avvikelse',
      high: 'Hög',
      medium: 'Medelhög',
      low: 'Låg',
      closed: 'Stängt',
      registered: 'Registrerad',
      process: 'Bearbeta',
      actions: 'Åtgärder',
      title: 'Titel',
      reported_by: 'Rapporterat av',
      location: 'Plats',
      reason: 'Orsak',
      document: 'Dokument',
      category: 'Kategori',
      estimate_cost: 'Kostnadsberäkning',
      severity: 'Svårighetsgrad',
      deviation_status: 'Avvikelse Status',
      deadline: 'Tidsfrist',
      description: 'Beskrivning',
      responsible: 'Ansvarig',
      copyto: 'Kopia till',
      upload_files: 'Ladda upp',
      required_message: 'Detta fält är obligatoriskt',
      consequences: 'Konsekvens',
      changeRequest: 'Ändringsbegäran',
      hse: 'HMS',
      deviation_number: 'Avvikelsenummer',
      underlying_reason: 'Underliggande orsak',
      corrective_actions: 'Korrigerande åtgärder',
      effect_of_measures: 'Effekt av åtgärder',
      sectionRegistration: 'Registrering',
      sectionClassification: 'Klassificering',
      sectionFollowUp: 'Uppföljning',
      sectionWhatHappened: 'Vad hände',
      sectionCorrectiveAction: 'Korrigerande åtgärd',
      sectionAttachments: 'Bilagor',
      readonlyNotice: 'Du har inte behörighet att redigera denna avvikelse. Fälten visas endast som information.'
    },
    checklist: {
      title: 'Checklista',
      updateChecklist: 'Uppdatera checklistan',
      pickCheckList: 'Välj en checklista',
      addCheckList: 'Lägg till checklista',
      hmsKs: 'HMS/KS',
      templateName: 'Mallnamn',
      checklist_recipients: 'E-postmottagare',
      checklist_recipient_hint: 'Ange e-post med komma(,) separerad.',
      projectnr: 'PO nr.',
      projectname: 'Projektnamn',
      aonr: 'AO nr.',
      workordername: 'Arbetsordernamn',
      customer: 'Kund',
      customercontact: 'Kundkontakt',
      projectleader: 'Projektledare',
      importCSV: 'Importera CSV',
      CSVFileInfo: 'Här kan du importera data från en csv-fil till en checklista.',
      removeRow: 'Ta bort 1:a raden om den har rubriker.',
      sameOrederColumn: 'Se till att kolumnerna är i samma ordning som du har definierat i checklistan.',
      semicolonDelimiter: 'Använd semikolon som csv-avgränsare.',
      withoutImport: 'Utan import',
      addCSVFile: 'Lägg till CSV-fil',
      report_header: 'Rapportrubrik',
      copy_confirm: 'Vill du kopiera checklistan?',
      filter: 'Filtrera',
      apply: 'Tillämpa',
      image: 'Bild',
      no_comment: 'Ingen kommentar',
      action: 'Handling',
      cameraCapture: 'Ta bild',
      openCamera: 'Öppna kamera',
      takePhoto: 'Ta bild',
      uploadDocument: 'Öppna kamera och ladda upp foto',
      retake: 'Ta om'
    },
    equipments: {
      equipment: 'Utrustning',
      addEquipment: 'Lägg till utrustning',
      updateEquipment: 'Uppdatera utrustning',
      viewEquipment: 'Visa utrustning',
      active: 'Aktiv',
      quarantine: 'Karantän',
      discarded: 'Kasserad',
      warrantydate: 'Datum för garanti',
      dateofPurchase: 'Inköpsdatum',
      vendor: 'Leverantör',
      modelNumber: 'Modellnummer',
      product: 'Produkt',
      serialNumber: 'Serienummer',
      capacity: 'Kapacitet',
      groups: 'Grupper',
      plannedCalibration: 'Planerad kalibrering',
      scrapDate: 'Datum för skrotning',
      equipmentNumber: 'Utrustningens nummer',
      placement: 'Placering',
      notifyByEmail: 'Meddela via e-post',
      mustAllocateToProjectOrLocation: 'Utrustningen måste tilldelas antingen projekt eller plats.',
      confirm: 'Är du säker?',
      company: 'Företag'
    },
    customModule: {
      modules: 'Moduler',
      customModule: 'Anpassad modul',
      customModules: 'Anpassade moduler',
      uploadDocument: 'Ladda upp dokument',
      isCompleted: 'Är slutförd',
      add: 'Lägg till',
      urlNotFound: 'Nedladdningsadress inte hittad',
      completed: 'Slutförd',
      notCompleted: 'Inte slutförd',
      fileSizeLimitMsg: 'Gränsen för filstorlek har överskridits för en eller flera filer (Max.Limit {maxSize}MB).',
      invalidFileType: 'Filtypen är inte tillåten'
    },
    moduleReports: {
      title: 'Modulrapporter',
      chartyAxis: 'Antal poster (per modul)'
    },
    projectFeature: {
      drawingNumber: 'Ritning nr.',
      poRanked: 'PO Rankad',
      operator: 'Operatör',
      reportNumber: 'Rapport nr.',
      uploadNdtDocument: 'Ladda upp NDT-dokument',
      aoRanked: 'AO Rankad',
      NDTSpecifications: 'NDT-specifikationer',
      NDTScope: 'NDT-omfattning',
      filterMaterials: 'Filtermaterial',
      chargedLotNumber: 'Charde/Lot nr.',
      selectFiles: 'Välj filer',
      createdOn: 'Skapad den',
      weldingID: 'Svetsning ID',
      weldNumber: 'Svetsnummer',
      wpsNumber: 'WPS nr.',
      wpsAsComma: 'Ange WPS nr. Som kommaseparerad.',
      weldEnd: 'Slut på svetsning',
      vtSignDate: 'VT Sign./Datum',
      rtSignDate: 'RT Sign./Datum',
      utSignDate: 'UT Sign./Date',
      mtPtSignDate: 'MT/PT Sign./Date',
      createdDate: 'Skapat datum',
      tegNr: 'Teg nr.',
      tegNrWpsNr: 'Teg nr. / Wps nr.',
      posNr: 'Pos nr.',
      batchNr: 'Parti nr.',
      heatNr: 'Värme nr.',
      onStock: 'I lager',
      weldingConsumable: 'Svetsförbrukning',
      registerBatchAgainstWps: 'Registrera batchnr. mot en WPS, för svetsloggen',
      out: 'Utgående',
      sectionIdentification: 'Identifikation',
      sectionStock: 'Lager',
      sectionStatus: 'Status och bilagor',
      descriptionHint: 'Beskrivning',
      recordNumber: 'Registreringsnummer',
      chartSpeed: 'Hastighet i diagrammet',
      chartNumber: 'Diagramnummer',
      unrestrictedTo: 'Obegränsad till',
      restrictedRateOfRise: 'Begränsad Stigningshastighet',
      holdTemperatureRequired: 'Hålltemperatur som krävs',
      holdTemperatureActual: 'Hålltemperatur faktisk temperatur',
      holdTimeActual: 'Hålltid Faktisk hålltid',
      holdTimeRequired: 'Hålltid som krävs',
      restrictedRateDown: 'Begränsad hastighet nedåt',
      unrestrictedRateOfFall: 'Obegränsad fallhastighet',
      weldDate: 'Svetsdatum',
      performedBy: 'Utförd av',
      approvedBy: 'Godkänd av',
      approvedDate: 'Godkänt datum',
      weldLogDate: 'Svetsdatum',
      productNumber: 'Produktnummer',
      weldLength: 'Svetslängd (mm)',
      designation_1: 'Del 1 Beteckning',
      designation_2: 'Del 2 Beteckning',
      thickness_1: 'Tjocklek 1(mm)',
      thickness_2: 'Tjocklek 2(mm)',
      weld_diameter: 'Svetsdiameter (mm)',
      notAccepted: 'Inte accepterad',
      ndtStatus: 'Ndt-status',
      isDiameter: 'Är diameter',
      ndt: '%NDT',
      weldingCompound: 'Svetsmassa',
      batch_lot: 'Batc/lot',
      choose: 'Välja',
      pipe_description: 'Rörbeskrivning'
    },
    whsDashboard: {
      scanText: 'Skanna ordernummer eller streckkod',
      customerOrder: 'Kundbeställningar',
      receiveSupplierOrder: 'Ta emot leverantörsbeställningar',
      adjustmentOrders: 'Justeringsbeställningar',
      transferOrders: 'Överföringsorder',
      cycleCount: 'Räkna cykler',
      product: 'Produkt',
      supplierOrder: 'Leverantörsorder',
      returnOrder: 'Returorder'
    },
    ccsheet: {
      warehouse: 'Lager',
      created: 'Skapade',
      counted: 'Räknade',
      count: 'Räkning',
      reCount: 'Omräkning',
      closeComplete: 'Stäng och slutför',
      unit: 'Enhet',
      stock: 'Lager',
      scanLocation: 'Skanna eller ange plats',
      nextLoc: 'Nästa plats',
      info: 'Meddelande!',
      continueCount: 'Fortsätt räkna',
      clearAndRecount: 'Rensa och räkna om',
      completeRecount: 'Slutföra omräkning',
      ccsheetComplete: 'CCSheet kommer att fyllas i. Fortsätta?',
      noSheetFound: 'Inget CCSheet hittades!',
      noProductOnLocation: 'Ingen produkt finns på denna plats!',
      stockTake: 'Inventering för den valda platsen har redan utförts. Vill du fortsätta räkna på denna plats eller rensa data och utföra en ny inventering?',
      ccsheetAddProduct: 'Produkten har inte lagts till i detta ccsheet, vill du lägga till?'
    },
    product: {
      supplierartno: 'Leverantörens artikelnummer',
      supplier: 'Leverantörsnamn',
      barcode: 'Streckkod',
      noProductFound: 'Ingen produkt har hittats!',
      minQty: 'Min. antal',
      orderQty: 'Beställd kvantitet',
      qty: 'Antal',
      batch: 'Parti',
      scanLoc: 'Välj plats',
      noLocFound: 'Ingen plats hittad!'
    },
    order: {
      products: 'Produkter',
      avail: 'Tillgänglig',
      pickProducts: 'Välj produkter',
      ordered: 'Ord.',
      received: 'Rec.',
      pickedQty: 'Pic.',
      pickOrder: 'Plocka beställning',
      delivery: 'Del',
      rest: 'Vila',
      complete: 'Komplett',
      pick: 'Välj',
      scanProduct: 'Skanna streckkoden för en produkt',
      scanBatch: 'Skanna batchnummer',
      picked: 'Plockat',
      toPick: 'För att plocka',
      location: 'Plats',
      pickLocation: 'Välj plats',
      qtyExceeds: 'Antal överstiger',
      noOrderFound: 'Ingen order hittad!',
      notValidBatch: 'Batchnumber är inte giltigt!',
      receiveOrder: 'Ta emot beställning',
      receive: 'Ta emot',
      batchExists: 'Batchnumret finns redan!',
      receiveWarning: 'Vill du lägga till {qty} st av {product} i lagret?',
      completedSuccess: 'Avslutad med framgång!',
      addFreight: 'Vill du lägga till frakt?',
      cost: 'Kostnad',
      price: 'Pris',
      orderedQtyHigh: 'Den mottagna kvantiteten är högre än den beställda, vill du fortsätta?',
      collect: 'Samla in',
      receiving: 'Mottagande',
      availableToPick: 'Tillgänglig(a) kvantitet(er) att ta emot',
      adjust: 'Justera',
      orderComplete: 'Beställningen kommer att slutföras. Fortsätt?',
      orderDate: 'Orderdatum'
    },
    tasks: {
      forYour: 'För din',
      information: 'information',
      acknowledge: 'Bekräfta',
      review: 'Granska',
      approval: 'Godkännande',
      subject: 'Ämne',
      dueDate: 'Förfallodag',
      approve: 'Godkänna',
      disapprove: 'Avslås',
      keep: 'Behåll',
      remove: 'Ta bort'
    },
    mixed: {
      scanSerialNumber: 'Skanna serienummer',
      noEquipmentFound: 'Ingen utrustning hittades',
      sharedUrl: 'Delad URL',
      checklistfiles: 'Checklista filer',
      attachments: 'Bilagor',
      signature: 'Signatur',
      nochecklists: 'Inga checklistor',
      checklistName: 'Checklista namn',
      noOfDocuments: 'Antal dokument',
      documentTitle: 'Dokument titel',
      irscanner: 'Ir-skanner',
      qrCode: 'QR-kod',
      qrQty: 'QR-antal',
      scanQRCode: 'Skanna QR-kod',
      attachmentsBelow: 'Hitta bilagor nedan',
      noChemicalFound: 'Ingen kemikalielista hittades',
      barCodeNotDecoded: 'Misslyckades med att dekoda streckkoden från QR-koden.',
      scanBarcode: 'Skanna streckkod'
    },
    chemicallist: {
      chemical: 'Kemisk',
      provider: 'Leverantör',
      repository: 'Förvar',
      last_revised: 'Senast reviderad',
      viewChemical: 'Kemisk',
      chemicalName: 'Kemiskt namn'
    },
    news: {
      news: 'Nyheter',
      next: 'Nästa',
      previous: 'Föregående'
    },
    // Production series (WIT-PROTO-PRODSERIES-PWA-001). Copy mirrors the
    // backend's resources/lang/sv/production_series.php (key in comment).
    productionSeries: {
      idModeSpool: 'Spool/part no.', // id_mode_spool
      idModeSeq: 'Without spool/part no. — sequence number', // id_mode_seq
      seriesOf: 'Series', // series_of
      nWelds: '{n} welds', // n_welds
      hasProductionData: 'Has production data', // has_production_data
      unitsWelds: '{units} units · {welds} welds', // units_welds
      unitRetainedSuffix: ' · retained', // unit_retained_suffix
      markerDone: '{done}/{total} welded', // marker_done
      noUnit: 'no spool/part no.' // Decision B tag (task copy)
    },
    weldMapping: {
      // 5183 / S18: one batch/heat per welding method.
      methodBatchesLabel: 'Batch/charge per metod',
      methodBatchesHint: 'Den här svetsen använder mer än en svetsmetod. Registrera batchen som använts för varje.',
      // 5183 / S4: production-series units under a drawing.
      unitsHeading: 'Spool-/delnummer',
      unitScoped: 'Visar spool {unit}',
      unitShowAll: 'Visa alla',
      unsavedHint: 'Osparade ändringar — använd knappen nedan för att förkasta dem',
      batchMissing: 'Batch/charge inte registrerad — fyll i innan du slutför',
      supersededBy: 'Ersatt av {weld} — registrera reparationen på den svetsen',
      previewWps: 'Förhandsgranska WPS',
      comment: 'Kommentar',
      copyMaterial: 'Kopiera material',
      vtRejectedOn: 'VT underkänd på',
      by: 'av',
      reason: 'Orsak:',
      repairOf: 'Reparation av',
      wireBatchTitle: 'Svetstråd · batch/charge',
      batchPf: 'Batch svetstillsats',
      batchPfHint: 'Skanna eller skriv batch…',
      assemblyPf: 'Sammanställning (PF) certifikat (valfritt)',
      weldCertificate: 'Svetsarcertifikat',
      certGroupQualified: 'Kvalificerad',
      certGroupCannotVerify: 'Kan inte verifieras',
      certGroupNotQualified: 'Ej kvalificerad',
      certNoneQualified: 'Inga kvalificerade certifikat för denna svets',
      certLockedTitle: 'Svetsen är låst — certifikat saknas',
      certLockedMsg: 'Du har inget certifikat som kvalificerar för denna svets. Kontakta svetskoordinatorn.',
      certAdvisoryTitle: 'Certifikat inte bekräftat',
      certAdvisoryMsg: 'Inget av dina certifikat kunde bekräftas för den här svetsen. Du kan ändå signera — valet loggas på svetsen.',
      // WIT-FIX-CERT-5348-001 F5a: the advisory is a not_qualified finding, not cannot_verify.
      certNotQualifiedTitle: 'Inte täckt av certifikat',
      // WIT-FIX-CERT-5355-001 F5a / D-5355-3 (Erik 15.10): what none of the welder's certificates covers, then how to go on.
      certNotQualifiedMsg: 'Inget av dina certifikat täcker denna svets{codes}. Du kan signera med en motivering — svetskoordinatorn ser den.',
      certNotQualifiedLead: 'Inget av dina certifikat täcker denna svets.',
      certSignWithReasonHint: 'Du kan signera med en motivering — svetskoordinatorn ser den.',
      certReasonWelder: 'Skriv kort varför du signerar utan kvalificerande certifikat (t.ex. «certifikat inte registrerat ännu»). Svetskoordinatorn ser motiveringen i svetsloggen.',
      certNoValidMsg: 'Du har inget giltigt svetscertifikat för den här svetsen. Du kan signera — svetsen flaggas för svetskoordinatorn.',
      certMissingProcess: ' (metod {codes} saknas)',
      // F2: the office override on the sheet (server weld_mapping.cert_ui.override_tip_* twins).
      certOverrideTipReason: 'Skäl: {reason}',
      certOverrideTipBy: 'Av: {by}',
      certOverrideTipAt: 'När: {at}',
      certAutoHint: 'Väljs automatiskt bland dina giltiga certifikat när du trycker «Färdigsvetsad».',
      certConfirmTitle: 'Bekräfta certifikat',
      certConfirmBtn: 'Bekräfta',
      // WIT-FIX-RETEST-1008-001 P-C: under the confirm intro, only for «Kan ikke verifiseres».
      certConfirmManualNote: 'Your choice is marked «Confirmed manually» and shown to the welding coordinator.',
      // P-C: the chip for a welder's own confirmation (cert_verdict cannot_verify_confirmed).
      certVerdictConfirmed: 'Bekräftad manuellt',
      // P-D: the stop under «Blokker» when nothing the welder holds can apply.
      certBlockedTitle: 'The weld cannot be registered',
      certOverrideTitle: 'Inte täckt av certifikat',
      certOverrideBlock: 'Projektet kräver kvalificerande certifikat. Ange en motivering för att signera ändå — svetskoordinatorn ser den i svetsloggen.',
      certOverrideWarn: 'Svetsen signeras och flaggas för svetskoordinatorn. Du kan lägga till en motivering.',
      certReasonLabel: 'Motivering',
      certReasonRequired: 'Motivering krävs.',
      // WIT-FIX-WELDMAP-002 (3.4 / 3.5) — needs native review
      certRankedTitle: 'Dina certifikat för denna svets:',
      welderIdMissing: 'Svetsar-ID saknas',
      welderIdMissingHint: 'Signerad utan svetsar-ID — lägg in svetsar-ID i din användarprofil.',
      certSignBtn: 'Signera',
      certLockedOverride: 'Du kan signera med en motivering — svetskoordinatorn ser den.',
      certVerdictQualified: 'Kvalificerad',
      certVerdictUnverified: 'Ej verifierad',
      certVerdictNotQualified: 'Ej kvalificerad',
      certVerdictNotChecked: 'Inte kontrollerad',
      // WIT-IMPL-CERT-001 P2/P3
      certVerdictOverride: 'Åsidosatt',
      certFlaggedToast: 'Signerad och flaggad för svetskoordinatorn.',
      undoSign: 'Ångra signering',
      undoSignDone: 'Signeringen av {weld} är ångrad.',
      // WIT-IMPL-CERT-001 P4 (office picker)
      certShowAllWelders: 'Visa alla svetsare i företaget',
      certNonParticipant: 'inte projektdeltagare',
      certNonParticipantReason: 'Svetsaren är inte projektdeltagare. Ange en motivering — valet sparas som åsidosättning.',
      noServerAnswer: 'Inget svar från servern. Kontrollera anslutningen och försök igen — ingenting sparades.',
      certMatchChecking: 'Kontrollerar certifikat…',
      // WIT-FIX-PWA-WELDERCERT-001 (Erik 09.10.2026): the welder's own picker.
      certAutoPick: 'Väljs automatiskt · {n} aktuella',
      certOwnHeading: 'Dina aktuella certifikat',
      certOwnHidden: 'Dolda: {n} av dina certifikat täcker inte metod/svetstyp.',
      certNoCertificates: 'Du har inget svetscertifikat registrerat. Kontakta svetskoordinatorn.',
      certNoneRelevant: 'Du har inget certifikat som kvalificerar för svets {weld}. Kontakta svetskoordinatorn.',
      assemblyPfHint: 'Välj certifikat …',
      search: 'Sök',
      nSelected: '{n} valda',
      assemblyPfNone: 'Inga certifikat tillgängliga',
      batchPfRequired: 'Ange batch för svetstillsats för att slutföra sammanställningen',
      required: 'obligatoriskt',
      rejectWhy: 'Varför underkänns fogen?',
      rejectNote: 'Notering (valfritt)',
      vtLevelIso: 'VT-nivå (ISO 5817)',
      vtLevelFromWeld: 'Satt på svetsen',
      vtLevelOverriding: 'Ändrar nivå',
      vtLevelNotSet: 'Inte satt',
      vtLevels: {
        B: 'Sträng',
        C: 'Medel',
        D: 'Måttlig'
      },
      faults: {
        undercut: 'Underskärning',
        porosity: 'Porer',
        spatter: 'Sprut',
        fusion: 'Bindfel',
        geometry: 'Geometri',
        other: 'Annat'
      },
      uploading: 'Laddar upp…',
      photoSaved: 'Foto sparat',
      fromWps: 'från WPS',
      change: 'Ändra',
      batchCharge: 'Batch / chargenr.',
      batchChargeHint: 'Välj batch …',
      batchAdd: 'Lägg till',
      batchAddNew: '+ Lägg till ny batch …',
      batchGroupWps: 'För denna WPS',
      batchTypeNew: 'Annan… (skriv ny batch)',
      batchPickFromList: 'Välj från listan',
      takePhoto: 'Ta foto',
      uploadPhoto: 'Ladda upp foto',
      signedAs: 'Signerad med din användare',
      title: 'Svetskartläggning',
      featureDisabled: 'Du har inte behörighet till Svetskartläggning.',
      searchDrawing: 'Sök ritning',
      continue: 'Fortsätt',
      lastOpened: 'Senast öppnad',
      allDrawings: 'Alla ritningar',
      childDrawings: 'Underritningar',
      welds: 'svetsar',
      hasChildren: '{count} underritningar',
      noMatch: 'Inga ritningar matchar',
      noMatchHint: 'Prova ett annat ritningsnummer.',
      mapComingNext: 'Svetskartan öppnas här i nästa steg.',
      drawingsShort: 'Ritningar',
      prevDrawing: 'Föregående ritning: {number}',
      nextDrawing: 'Nästa ritning: {number}',
      firstDrawing: 'Första ritningen',
      lastDrawing: 'Sista ritningen',
      ownJoints: 'Egna svetsar',
      ownMap: 'Öppna svetskarta för {number}',
      ownSub: '{count} svetsar på själva ritningen',
      joints: 'Svetsar',
      toggleJoints: 'Visa eller dölj svetslistan',
      noJoints: 'Inga svetsar på denna ritning',
      // Which STAGE a drawing has reached (D-5170-1).
      drawingStage: {
        pending: 'Not started',
        mapping: 'Being mapped',
        mapped: 'Mapped',
        welding: 'Being welded',
        ndt: 'Awaiting inspection',
        // «VT fullført» (WIT-IMPL-PWA-DRAWINGSTATUS-003): alt sveist og VT
        // signert, men en annen påkrevd NDT-metode gjenstår.
        vt_done: 'VT klar',
        done: 'Complete'
      },
      status: {
        MAPPED: 'Kartlagd',
        FITTED: 'Sammanställd',
        WELDED: 'Svetsad',
        COMPLETED: 'Slutförd',
        REPAIR: 'Reparation'
      },
      wps: 'WPS',
      process: 'Metod',
      filler: 'Tillsats',
      vtLevel: 'VT-nivå',
      trace: 'Spårning',
      fittedBy: 'Sammanställd av',
      weldedBy: 'Svetsad av',
      vtBy: 'VT av',
      batch: 'batch',
      wire: 'tråd',
      level: 'nivå',
      vtRejectedBy: 'VT avvisad av',
      vtPending: 'Väntar på VT-kontroll',
      field: {
        title: 'Field-registered weld',
        legend: 'Field-registered (awaiting office)',
        addBtn: 'Add weld in field',
        placeHint: 'Tap the drawing where the new weld goes',
        cancel: 'Cancel',
        queued: '{n} registration(s) waiting for connection',
        syncNow: 'Sync now',
        wpsDeviation: 'WPS deviation',
        newTitle: 'New weld – field-registered',
        editTitle: 'Edit field-registered weld',
        newSub: 'Registered by the welder on site and flagged for review by the office.',
        loadingOptions: 'Loading registers…',
        after: 'After weld',
        weldNr: 'Weld no.',
        idHint: 'Letter + the preceding weld\'s number: the first between W-0005 and W-0006 becomes A-0005, then B-0005, C-0005 …',
        reason: 'Reason',
        pickReason: 'Choose reason…',
        pick: 'Choose…',
        joint: 'Joint',
        groove: 'Groove type',
        pickGroove: 'Choose groove type…',
        pickJointFirst: 'Choose joint first',
        pickWps: 'Choose WPS…',
        material: 'Base material',
        materialsFailed: 'The material register could not be loaded. Try again, or tell the office.',
        thickness: 'Thickness (mm)',
        weldLength: 'Length mm',
        spool: 'Spool/part no.',
        pickSpool: 'Select spool/part no.…',
        spoolHint: 'This drawing has several spool/part numbers — pick the one this weld is on.',
        validRange: 'valid {min}–{max} mm',
        warnNotBlocking: 'The weld can be saved, but the deviation is flagged to the office.',
        warnMaterial: 'Material {material} is not covered by {wps}.',
        warnThickness: 'Thickness {t} mm is outside the WPS validity range ({min}–{max} mm).',
        // WIT-IMPL-WPS-5324-003 (F4): weld_mapping.field_wps_no_process twin.
        warnNoProcess: 'WPS {wps} saknar svetsmetod – certifikatet kan inte verifieras.',
        optional: 'optional',
        notePh: 'E.g. location, deviation, reference…',
        save: 'Save weld',
        registeredToast: '{weld} registered — sent to the office for review',
        queuedToast: '{weld} saved on the device — sent to the office when back online',
        updated: '{weld} updated',
        registered: 'Registered',
        reviewComment: 'Comment from the office',
        office: 'Office',
        approve: 'Approve',
        reject: 'Reject',
        remove: 'Remove from drawing',
        edit: 'Edit registration',
        rejectedNote: 'Rejected by the office — remove it or register the weld again.',
        localPending: 'Waiting for connection — not yet sent to the office.',
        delete: 'Delete registration',
        deleteConfirm: 'Delete {weld}? The registration is removed from the drawing and the weld log.',
        deleteHasData: 'The weld has production data ({status}) and cannot be deleted here.',
        decision: {
          rejected: 'Rejected by the office',
          approved: 'Approved by the office'
        },
        notifications: 'Notifications',
        noNotifications: 'No notifications',
        status: {
          pending: 'Field-registered',
          approved: 'Approved',
          rejected: 'Rejected'
        },
        sub: {
          pending: 'awaiting office approval',
          approved: 'field-registered · approved',
          rejected: 'rejected by the office',
          local: 'waiting for sync'
        },
        reasons: {
          missed_in_mapping: 'Missed in mapping',
          unforeseen_pipe_joint: 'Unforeseen pipe joint',
          site_change: 'Site change',
          other: 'Other'
        },
        joints: {
          BW: 'BW – Butt weld',
          FW: 'FW – Fillet weld',
          'BW-ROR': 'BW – Pipe joint'
        },
        grooves: {
          V: 'V-groove',
          X: 'X-groove',
          I: 'I-groove',
          U: 'U-groove',
          HV: 'HV-groove',
          J: 'J-groove',
          FILLET_A: 'Fillet (a-dimension)'
        },
        notif: {
          field_weld_registered: '{weld} registered in the field — review needed',
          field_weld_approved: '{weld} approved by the office',
          field_weld_rejected: '{weld} rejected by the office'
        }
      },
      // WIT-IMPL-M101-PWA-001: read-only NDT context per joint (server-derived)
      // and the hold-welding warning carrier. Never a block.
      ndtContext: {
        title: 'NDT context',
        classDefault: 'Class',
        classM101: 'Inspection category (NORSOK N-004)',
        classM601: 'NDT group (NORSOK M-601 table 2)',
        jointType: 'Joint type',
        weldType: 'Weld type',
        penDepth: 's (mm)',
        holdTime: 'Hold time before NDT',
        earliestNdt: 'Earliest NDT',
        pending: 'To be clarified',
        status: 'Status',
        hold: {
          pwht: 'none (NDT after PWHT)',
          default_48: '48 h',
          smys_le_355: '24 h (SMYS ≤ 355, documented)',
          smys_le_460_thin: '24 h (SMYS ≤ 460 and t < 40 mm, documented)',
          smys_missing: '48 h (yield strength missing)',
          thickness_missing: '48 h (thickness missing)',
          // WIT-FIX-M101-001: table G.1 fixed hold; no SMYS because the material is unlinked.
          g1_fixed_48: '48 h (10.1)',
          material_unlinked: '48 h – materialet är inte kopplat till standardmaterial',
          // WIT-IMPL-SVV-R761-002: NS-EN 1090-2 table 23 (SVV R761).
          table23: '{h} h (NS-EN 1090-2 tabell 23)',
          table23_cooling: 'bara avkylning (tabell 23)',
          table23_pending: 'måste klargöras (tabell 23)',
          drawing: '{h} h (drawing)',
          default: '{h} h',
          none: 'none registered'
        }
      },
      weldingHold: {
        flag: 'Welding hold',
        wps: 'Welding hold on WPS {wps}',
        welder: 'Welding hold for the welder',
        since: 'since {date}',
        notBlocking: 'Warning – the weld can be registered, the office has been notified.'
      },
      pendingSync: 'Väntar på synk',
      noSymbol: 'Symbol saknas',
      noExecution: 'Inget utförande registrerat än',
      close: 'Stäng',
      noDrawingFile: 'Ingen ritning uppladdad',
      noPreview: 'Förhandsvisning ej tillgänglig',
      imageFailed: 'Ritningsbilden kunde inte laddas',
      roles: {
        fitter: 'Plåtarbetare',
        welder: 'Svetsare',
        vt: 'VT-kontroll'
      },
      hints: {
        fitter: '{n} svetsar väntar på sammanställning',
        fitterDone: 'Alla sammanställningar klara!',
        welder: '{n} klara för svetsning',
        welderNone: 'Inga klara — väntar på sammanställning',
        welderNdt: 'Alla svetsar klara — {n} väntar på NDT-kontroll',
        welderDone: 'Alla svetsar klara och kontrollerade!',
        vt: '{n} väntar på VT-kontroll',
        vtDone: 'Inget väntar på VT — allt kontrollerat!',
        vtNdtOpen: '{n} VT-godkända — väntar på övrig NDT (signeras på webben)'
      },
      materials: 'Materialspårning',
      heat: 'Heat/charge',
      heatMissing: 'Heat saknas',
      bulkFitUp: 'Sammanställd',
      bulkWeldEnd: 'Svetsad',
      bulkWeldList: 'Signerar dessa svetsar',
      changeHistory: 'Ändringslogg',
      auditField: {
        fillerBatch: 'Svetsbatch',
        batchPf: 'Sammanställningsbatch',
        filler: 'Tillsats',
        certificateRefs: 'Svetscertifikat',
        assemblyPf: 'Sammanställningscertifikat',
        vtLevel: 'VT-nivå',
        // WIT-FIX-CERT-5348-001 F2: the certificate decision in Endringslogg.
        certVerdict: 'Certifikatkontroll',
        certOverrideReason: 'Skäl för åsidosättning',
        certUnqualifiedSign: 'Signerad utan kvalificerande certifikat',
        traceabilityGaps: 'Signerad med saknad spårbarhet',
        certRegisteredLater: 'Certifikat registrerat i efterhand'
      },
      auditFrom: 'Från',
      auditTo: 'Till',
      auditNoChange: 'Sparad utan ändringar',
      auditAction: {
        add: 'Tillagd',
        flag: 'Flaggad',
        update: 'Ändrad',
        delete: 'Borttagen'
      },
      posLabel: 'Pos',
      posNrMissing: 'Pos.nr saknas',
      noMaterials: 'Inga material i planen',
      addMaterial: 'Lägg till',
      newMaterial: 'Nytt material',
      editMaterial: 'Ändra material',
      materialHint: 'Skanna märket på stålet, eller skriv in manuellt.',
      scanQr: 'Skanna märket (QR)',
      scanNfc: 'RFID/NFC',
      scanComingNext: 'Skanning kommer senare — skriv in manuellt nedan',
      orManual: 'ELLER SKRIV MANUELLT',
      materialType: 'Materialtyp',
      selectType: 'Välj materialtyp',
      editFieldHint: 'Endast fälten du ändrar sparas. Signatur, datum och VT berörs inte.',
      noTypeMatches: 'Inga träffar',
      noTypesInRegister: 'Inga materialtyper i registret',
      heatNo: 'Heat / charge-nr',
      heatTypeNew: 'Annan… (skriv nytt heat-nr)',
      heatFromMaterialList: 'Från materiallistan',
      thickness: 'Tjocklek (mm)',
      posNo: 'Pos nr',
      saveChanges: 'Spara ändringar',
      gapWarnTitle: 'Saknade uppgifter',
      gapWarnHint: 'Den här fogen saknar uppgifter i materialspårbarheten. Signera ändå?',
      gapWarnYes: 'Ja, signera ändå',
      gapWarnNo: 'Nej, fyll i nu',
      gapThickness: 'saknar tjocklek',
      gapType: 'saknar materialtyp',
      gapRow: 'Rad {n}',
      bulkSignVt: 'VT-godkänn alla {n}',
      bulkConfirm: 'Bekräfta',
      bulkTitleVt: 'VT-godkänn alla klara svetsar',
      bulkHint: 'Godkänner de {n} svetsar som väntar på VT på den här ritningen. Saknade uppgifter visas efteråt.',
      bulkSigned: '{n} signerade',
      bulkSkipped: '{n} överhoppade',
      bulkGapsTitle: 'Luckor i spårbarheten',
      bulkGapsHint: 'Dessa svetsar saknar uppgifter. Du kan godkänna ändå, eller avbryta och komplettera först.',
      gapHeat: 'saknar heat',
      gapPosNr: 'saknar pos nr',
      gapNoMaterials: 'inga material',
      cancel: 'Avbryt',
      removeMaterial: 'Ta bort material',
      saving: 'Sparar…',
      repairNote: 'VT avvisade denna — åtgärda och registrera på nytt.',
      actFitUp: 'Sammanställning klar',
      actWeld: 'Färdigsvetsad',
      actRepair: 'Reparerad och svetsad',
      actVtOk: 'VT godkänd — nivå {level}',
      actVtReject: 'Avvisa — skicka till reparation',
      actionsComingNext: 'Registrering kopplas in i nästa steg',
      vtSignedNdtOpen: 'VT godkänd — övrig NDT återstår',
      noAction: 'Ingen {role}-åtgärd på denna svets nu ({status})'
    },
    advancedWeldLog: {
      // 5183 / R-2.7c: the production-series column in the weld list.
      spoolNo: 'Spool-/delnr.',
      // 5183 / R-2.7d: route to the weld-mapping screen, where the flow lives.
      addFieldWeld: 'Lägg till svets i fält',
      noDrawingsFound: 'Inga ritningar hittades',
      folderLIst: 'Mapplista',
      projectDrawings: 'Projektritningar',
      drawingNumber: 'Ritningsnummer',
      weldCount: 'Antal svetsar',
      engineering: 'Teknik',
      production: 'Produktion',
      ndt: 'NDT',
      pending: 'Väntande',
      inProgress: 'Pågår',
      completed: 'Färdig',
      ndtFaultScope: 'NDT felomfång',
      submit: 'Skicka',
      cancel: 'Avbryt',
      newWeldLog: 'Svetslogg',
      updateWeldLog: 'Uppdatera logg',
      weldNo: 'Svets nr',
      jointType: 'Fogtyp',
      wps: 'WPS',
      weldingConsumables: 'Svetsförbrukning',
      batchNumber: 'Heat / Batch nr',
      welderCertificates: 'Svetsarcertifikat',
      weldEnd: 'Svets slut',
      ok: 'Ok',
      sign: 'Signera',
      comments: 'Kommentarer',
      notAcceptable: 'Ej godkänt',
      fault: 'Fel',
      noResultsFound: 'Inga resultat hittades.',
      drawing: 'Ritning',
      projectName: 'Projektnamn',
      aoRanked: 'AO rankad',
      poRanked: 'PO rankad',
      searchWeldLogs: 'Sök svetsloggar',
      confirmWeldLogDelete: 'Är du säker på att du vill ta bort svets {weld_nr}?',
      weldingProcess: 'Svetsprocess',
      ndts: 'NDT:er',
      searchDrawings: 'Sök ritningar',
      selectDrawing: 'Välj en ritning',
      noWeldLogResultsFound: 'Inga svetsloggar hittades!',
      selectDrawingToLoadWeldLogs: 'Välj en ritning för att ladda svetsloggar!',
      certificateRequiredWhenWeldEnd: 'Certifikat krävs när Svets slut är valt.'
    }
  }
}
